import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FileModel } from '../../../models/file/file.model';
import { ProjectExpenseModel } from '../../../models/finance/expense.model';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../../services/controls/shive-notification.service';
import * as fromStatusActions from '../status/status.actions';
import * as fromProjectExpensesActions from './project-expenses.actions';

@Injectable({
  providedIn: 'root',
})
export class ProjectExpensesHttpService {
  private readonly store = inject(Store);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly actions$ = inject(Actions);

  constructor() {
    this.handleHttpCallbacks();
  }

  public getExpenses(): Observable<readonly ProjectExpenseModel[]> {
    this.store.dispatch(fromProjectExpensesActions.fetchProjectExpenses());

    return this.actions$.pipe(
      ofType(fromProjectExpensesActions.setProjectExpenses),
      map((result) => result.payload),
    );
  }

  public addProjectExpense(projectExpenseModel: ProjectExpenseModel): Observable<unknown> {
    this.store.dispatch(
      fromProjectExpensesActions.addProjectExpense({
        payload: projectExpenseModel,
      }),
    );

    return this.actions$.pipe(ofType(fromProjectExpensesActions.projectExpenseAdded));
  }

  public updateProjectExpense(
    updatedProjectExpense: ProjectExpenseModel,
    oldAttachment: FileModel,
  ): Observable<unknown> {
    this.store.dispatch(
      fromProjectExpensesActions.updateProjectExpense({
        payload: {
          updatedProjectExpense,
          oldAttachment,
        },
      }),
    );

    return this.actions$.pipe(ofType(fromStatusActions.projectStatusUpdated));
  }

  public deleteProjectExpense(
    toBeDeletedProjectExpense: ProjectExpenseModel | ProjectExpenseModel[],
  ): Observable<unknown> {
    this.store.dispatch(
      fromProjectExpensesActions.deleteProjectExpense({
        payload: toBeDeletedProjectExpense,
      }),
    );

    return this.actions$.pipe(ofType(fromStatusActions.projectStatusDeleted));
  }

  private handleHttpCallbacks(): void {
    this.actions$
      .pipe(
        ofType(
          fromProjectExpensesActions.projectExpenseAdded,
          fromProjectExpensesActions.projectExpenseUpdated,
          fromProjectExpensesActions.projectExpenseDeleted,
        ),
      )
      .subscribe(() => {
        // const message = this.localizationService.getTranslation(payload.responseCode);
        this.shiveNotificationService.show(NotificationType.Success);
      });
  }
}
